
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from './assets/images/favicon.ico';
import Layout from "./components/Layout";
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
// import UrbanaidUniworld from './pages/UrbanaidUniworld';
import Contact from './pages/Contact';
import Archives from './pages/Archives';
import Videos from "./pages/Videos";
import Testimonials from "./pages/Testimonials";
import logo from './assets/images/uai-logo.png';

function App() {
  const title='Best Real Estate Company Lucknow | Urbanaidinfratech';
  const description='Urbanaidinfratech is one of the leading Real Estate company in Lucknow. Get luxurious homes in ready to move condition at most prime locations at lucrative prices.';
  const canonical='/home';
  

  return (
    <div id='page' className='text-base'>
    <HelmetProvider>
      <Helmet>
        <html lang="en" />
        <meta charset="utf-8" />  
        <link rel="icon" href={favicon} />  
        <meta name="viewport" content="width=device-width, initial-scale=1" />  
        <title>{title}</title>
        <meta name="robots" content="index, follow"/>
        <meta name="googlebot" content="index, follow" />
        <meta name="copyright" content="© Copyright 2024 Urbanaid Infratech. All rights reserved"/>
        <meta name="description" content={description} />
        <link rel="canonical" href={canonical} />
        <meta name="google-site-verification" content="" />
        <meta property="og:locale" content="IN_IND" /> 
        <meta property="og:type" content="@UrbanaidInfratech" />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:url" content="" />
        <meta property="og:image" content={logo} />
        <meta property="fb:app_id" content="" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@UrbanaidInfratech" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content="" />
        <meta name="twitter:image:alt" content="" />
      </Helmet>
    </HelmetProvider>
    <BrowserRouter>
    <Routes>
      <Route path='/' element={<Layout><Home /></Layout>} />
      <Route path='/about-us' element={<Layout><About /></Layout>} />
      <Route path='/projects/:slug' element={<Layout><Projects /></Layout>} />
      {/* <Route path='/urbanaiduniworld' element={<Layout><UrbanaidUniworld /></Layout>} /> */}
      <Route path='/videos' element={<Layout><Videos /></Layout>} />
      <Route path='/contact-us' element={<Layout><Contact /></Layout>} />
      <Route path='/archives' element={<Layout><Archives /></Layout>} />
      <Route path='/testimonials' element={<Layout><Testimonials /></Layout>} />
    </Routes>
    </BrowserRouter>
    </div>
  );
}

export default App;
